<kendo-formerror>
    <span>{{ message$ | async }}</span>
</kendo-formerror>